import styled from "@emotion/styled";
import { Box, Grid, Typography } from "@mui/material";
import { mediaQueryMobileLimit } from "../../../../../utils/constants";

export const FooterStyled = {

  Container: styled(Grid) <any>`
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content: space-around;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);
    background-color: #3579ba;
    `,
  FooterLogoContainer: styled(Box) <any>`
    
    `,
  FooterLogo: styled(Typography) <any>`
        width: 100%;
        text-align: center;
        margin-top: 34px;
        margin-bottom: 32px;
        font-size: 20px;
        font-weight: bold;
        color: white;
        font-family: EncodeSans-Medium;
    `,
  FooterContentContainer: styled(Grid) <any>`
        display: flex;
        justify-content: center;
        margin-bottom: 32px;
        color: white;
        font-size: 16px;
        font-weight: bold;
        

        @media (max-width: ${mediaQueryMobileLimit}px) {
            gap:5px;
           };
        @media (min-width: ${mediaQueryMobileLimit}px) {
            & > :first-child {
                text-align: end;
              }
            & > :last-child {
                text-align: start;
              }
           };
    `,
  FooterContent: styled(Grid) <any>`
      display: flex;
      justify-content: center;
      text-align: center;
      font-family: EncodeSans-Medium;
      @media (max-width: ${mediaQueryMobileLimit}px) {
        font-size: 12px;
       }
    `,

  Email: styled.a <any>`
     text-decoration: none;
      color: white;
    `,

  FooterBottom: styled(Typography) <any>`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 53px;
        color: white;
        font-family: EncodeSans-Medium;
        font-size: 12px;
        background-color: #2567a5;
    `,
}
